module.exports = __webpack_public_path__ + "img/wechat.0e220870.svg";